window.salesInvoiceDownloadFormatter = function(value, row) {
    let html = '';
    html += '<a href="/facturen/download/'+row.id+'">';
    html += '<i class="fa fa-download"></i>';
    html += '</a>';
    return html;
}
